import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 pt-12 pb-6 mt-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row gap-10 mb-10">
          {/* 브랜드 */}
          <div className="flex-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-yellow-400 flex-shrink-0">
                <i className="ri-home-heart-line text-white text-lg" />
              </div>
              <span className="text-sm font-bold text-white leading-tight whitespace-nowrap">
                대구드레스룸<br />
                <span className="text-yellow-400">키친스</span>
              </span>
            </div>
            <p className="text-xs leading-relaxed text-gray-500">
              드레스룸/팬트리 전문 시공업체<br />
              수년간의 노하우로 최상의 제품을 제공합니다.
            </p>
          </div>

          {/* 회사 정보 */}
          <div className="flex-1">
            <h4 className="text-xs font-semibold text-gray-300 mb-3 uppercase tracking-widest">Company Info</h4>
            <ul className="flex flex-col gap-1.5 text-xs text-gray-500">
              <li>상호명: 대구드레스룸 키친스</li>
              <li>대표자: 신우창</li>
              <li>사업자등록번호: 503-17-45896</li>
              <li>주소: 대구광역시 북구 침산남로48</li>
              <li>전화: <a href="tel:053-766-0411" className="hover:text-yellow-400 transition-colors">053-766-0411</a></li>
              <li>팩스: 053-766-0412</li>
            </ul>
          </div>

          {/* 빠른 링크 */}
          <div className="flex-shrink-0">
            <h4 className="text-xs font-semibold text-gray-300 mb-3 uppercase tracking-widest">Quick Links</h4>
            <ul className="flex flex-col gap-2 text-xs">
              <li><Link to="/company" className="text-gray-500 hover:text-yellow-400 transition-colors">회사안내</Link></li>
              <li><Link to="/gallery" className="text-gray-500 hover:text-yellow-400 transition-colors">갤러리</Link></li>
              <li><Link to="/sample" className="text-gray-500 hover:text-yellow-400 transition-colors">시공사례</Link></li>
              <li><Link to="/contact" className="text-yellow-400 hover:text-yellow-300 transition-colors font-semibold">상담신청</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-gray-600">Copyright &copy; 2024 대구드레스룸 키친스. All Rights Reserved.</p>
          <a
            href="tel:053-766-0411"
            className="flex items-center gap-1.5 text-xs text-yellow-400 hover:text-yellow-300 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            053-766-0411
          </a>
        </div>
      </div>
    </footer>
  );
}
